import { Outlet } from "react-router-dom"

export const StudentsContainer = () => {
    return (
        <Outlet />
    )
}
